import { FeatureFlag } from 'constants/feature-flags';
import { useFeatureFlags } from 'hooks/use-feature-flags';
import { useHasPermission } from 'hooks/use-has-permission';

export const useManageCustomFlowsPermission = () => {
  const { featureFlags, isInitialized } = useFeatureFlags();
  const permission = featureFlags[FeatureFlag.REPOSITORY_CUSTOM_FLOWS_RBAC]
    ? 'MANAGE_CUSTOM_FLOWS'
    : 'EDIT_PROJECT_SETTINGS';
  return { permission, isLoading: !isInitialized } as const;
};

export const useCanManageCustomFlows = (opts: { projectId?: string } = {}) => {
  const { permission, isLoading: isLoadingFlag } = useManageCustomFlowsPermission();
  const { isAuthorized, isLoading: isLoadingPermission } = useHasPermission(permission, opts);
  return { isAuthorized: isAuthorized && !isLoadingFlag, isLoading: isLoadingPermission || isLoadingFlag };
};
